import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import { ARTIFACT_CONTROLS } from "@/payroll/editor/constants";
import { ComparisonGridSkeleton } from "./comparison-grid-skeleton";

/**
 * The whole Pay pane while its state is unknown.
 *
 * Four bands, in the order the real pane stacks them: the toolbar with its
 * period picker, the strip of sheet tabs, the change summary, then the
 * side-by-side. Reusing the grid skeleton below means the inner wait and the
 * outer wait draw the same thing, which is what makes the second one invisible.
 */
export const ComparisonSkeleton = () => (
  <section
    className="flex min-h-0 flex-1 flex-col"
    role="status"
    aria-label="Loading comparison…"
  >
    <div
      className={cn(ARTIFACT_CONTROLS, "flex flex-wrap items-center gap-1.5")}
      aria-hidden
    >
      {/* The period picker is a fixed 52-unit control, so it never resizes. */}
      <Skeleton className="h-7 w-52 rounded-md" />
      <Skeleton className="h-7 w-28 rounded-md" />
      <Skeleton className="ml-auto h-7 w-36 rounded-md" />
    </div>
    <Stack
      gap={0}
      align="stretch"
      direction="row"
      aria-hidden
      className="flex shrink-0 gap-1 border-b border-line px-3 py-1.5"
    >
      {["w-20", "w-28", "w-24", "w-32", "w-20"].map((width, index) => (
        <Skeleton key={index} className={cn("h-6 rounded-md", width)} />
      ))}
    </Stack>
    <Stack
      gap={0}
      align="stretch"
      direction="row"
      aria-hidden
      className="flex shrink-0 items-center gap-3 border-b border-line px-3 py-1.5"
    >
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-3 w-36" />
      <Skeleton className="h-3 w-20" />
    </Stack>
    <ComparisonGridSkeleton />
  </section>
);
